import { render, staticRenderFns } from "./ProductAssigner.vue?vue&type=template&id=7ea62b51&"
import script from "./ProductAssigner.vue?vue&type=script&lang=js&"
export * from "./ProductAssigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports